import React, { ComponentProps } from "react";

import { Route } from "react-router";

interface Props extends ComponentProps<typeof Route> {
  enabled: boolean;
}

export const ToggledRoute = (props: Props): JSX.Element | null => {
  const { enabled, ...rest } = props;

  if (!enabled) {
    return null;
  }

  return <Route {...rest} />;
};
